import ClassNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { largeUp } from 'constants/mediaQueries';
import Product from 'models/Product';
import Theme from 'styles/theme';

import Dropdown from './Dropdown';
import Grid from './Grid';
import Overview from './Overview';

const PdpSizeSelector = ({
  product,
  sizes,
  selectSize,
  currentSize,
  useDropdown,
  backorderMessage,
  isFinalSale,
  handleOpenSizing,
  soldOutMessage,
  productUpdatesTooltipEnabled,
  type,
  masterId,
  trackProductUpdatesTooltipView,
  showUrgencyMessaging,
  pdpStorytellingEnabled,
}) => {
  return (
    <div
      className={ClassNames('PdpSizeSelector', {
        'PdpSizeSelector--grid': !useDropdown,
        'PdpSizeSelector--dropdown': useDropdown,
      })}
      id="pdp-size-selector"
    >
      <Overview
        product={product}
        backorderMessage={backorderMessage}
        isFinalSale={isFinalSale}
        handleOpenSizing={handleOpenSizing}
        soldOutMessage={soldOutMessage}
        productUpdatesTooltipEnabled={productUpdatesTooltipEnabled}
        masterId={masterId}
        trackProductUpdatesTooltipView={trackProductUpdatesTooltipView}
        showUrgencyMessaging={showUrgencyMessaging}
      />
      {useDropdown ? (
        <Dropdown sizes={sizes} selectSize={selectSize} currentSize={currentSize} />
      ) : (
        <Grid
          sizes={sizes}
          selectSize={selectSize}
          currentSize={currentSize}
          handleOpenSizing={handleOpenSizing}
          type={type}
          masterId={masterId}
          pdpStorytellingEnabled={pdpStorytellingEnabled}
        />
      )}
      <style jsx>
        {`
          .PdpSizeSelector {
            margin-top: ${Theme.get('spacing') * 2}px;
            margin-bottom: ${Theme.get('spacing') * 1.5}px;
          }

          @media ${largeUp} {
            .PdpSizeSelector {
              margin-top: ${Theme.get('spacing') * 3.5}px;
              margin-bottom: ${Theme.get('spacing') * 2.5}px;
            }
          }
        `}
      </style>
    </div>
  );
};

PdpSizeSelector.propTypes = {
  product: PropTypes.instanceOf(Product).isRequired,
  sizes: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.number, value: PropTypes.string, available: PropTypes.bool })
  ).isRequired,
  selectSize: PropTypes.func.isRequired,
  currentSize: PropTypes.string,
  useDropdown: PropTypes.bool,
  handleOpenSizing: PropTypes.func,
  isFinalSale: PropTypes.bool,
  backorderMessage: PropTypes.string,
  soldOutMessage: PropTypes.string,
  productUpdatesTooltipEnabled: PropTypes.bool,
  type: PropTypes.string.isRequired,
  masterId: PropTypes.string.isRequired,
  trackProductUpdatesTooltipView: PropTypes.func,
  showUrgencyMessaging: PropTypes.bool.isRequired,
  pdpStorytellingEnabled: PropTypes.bool,
};

PdpSizeSelector.defaultProps = {
  useDropdown: false,
  isFinalSale: false,
  currentSize: null,
  backorderMessage: null,
  soldOutMessage: null,
  productUpdatesTooltipEnabled: false,
  trackProductUpdatesTooltipView: () => {},
};

export default PdpSizeSelector;
